import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import StudioHelpLayout from '../../components/studio/StudioHelpLayout';
import {
  legacyHashToHelpPath,
  STUDIO_HELP_SECTION_BY_ID,
} from './studioHelpCatalog';

export default function StudioHelpPage() {
  const { sectionId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/studio/help' && location.hash) {
      navigate(legacyHashToHelpPath(location.hash), { replace: true });
    }
  }, [location.pathname, location.hash, navigate]);

  if (!sectionId) {
    if (location.hash) {
      return <Navigate to={legacyHashToHelpPath(location.hash)} replace />;
    }
    return <Navigate to="/studio/help/overview" replace />;
  }

  if (!STUDIO_HELP_SECTION_BY_ID[sectionId]) {
    return <Navigate to="/studio/help/overview" replace />;
  }

  return <StudioHelpLayout sectionId={sectionId} key={sectionId} />;
}
